import { render, staticRenderFns } from "./purnolnvoiceview.vue?vue&type=template&id=65777c2d&scoped=true&"
import script from "./purnolnvoiceview.vue?vue&type=script&lang=js&"
export * from "./purnolnvoiceview.vue?vue&type=script&lang=js&"
import style0 from "./purnolnvoiceview.vue?vue&type=style&index=0&id=65777c2d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65777c2d",
  null
  
)

export default component.exports